import styled from "@emotion/styled";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  FormHelperText,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { addOrder, addSingleItem } from "../../store/Store/orderSlice";
import { convertToPlaces, getDiscountedPrice } from "../../helpers/helpers";
import { LIST_ITEM } from "../../constants/Constants";
import DeleteIcon from "@mui/icons-material/Delete";
import { authHeader } from "../../helpers";
import { apiConstants } from "../../constants";
import AlertToast from "../../components/common/Toast";

const StyledButton = styled(Button)({
  color: "white",
});

const StyledPriceButton = styled(Button)({
  color: "white",
  height: "40px",
});

const style = {
  background: "#FFFFFF",
  boxShadow:
    "0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "798px",
  minHeight: "174px",
  padding: "20px",
};

const AddItemModal = ({ ...props }) => {
  const { open, handleClose } = props;
  const { activeSport } = useSelector((state) => state.orders);
  const [data, setData] = useState([]);
  const [fabrics, setFabrics] = useState([]);
  const [linings, setLinings] = useState([]);
  const [extra, setExtra] = useState([]);
  const [selected, setSelected] = useState({});
  const [extraCharges, setExtraCharges] = useState([]);

  const dispatch = useDispatch();
  const [newItem, updateItem] = useState(LIST_ITEM);

  const [enableAdd, setEnableAdd] = useState(false);

  const [error, setError] = useState({ value: false, name: "", message: "" });
  const [fabricPriceId, setFabricPriceId] = useState("");
  const [priceId, setPriceId] = useState("");
  const [originalUnitPrice, setOriginalUnitPrice] = useState("");
  const [unitPriceError, setUnitPriceError] = useState(false);
  const [qty, setQty] = useState();
  const [discount, setDiscount] = useState("");

  const [toastState, setToastState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const [toastMessage, setToastMessage] = React.useState("");
  const handleToastClose = () => setToastState({ open: false });

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const clearAll = () => {
    setFabrics([]);
    setLinings([]);
    updateItem({ ...LIST_ITEM, sport_id: activeSport });
    handleClose();
    setExtraCharges([]);
    setSelected({});
  };
  const handleSave = () => {
    const addItem = {
      ...newItem,
      originalUnitPrice: originalUnitPrice,
      original_unit_price: newItem.original_unit_price,
      discount_percentage:
        newItem.discount_percentage === "" ? 0 : newItem.discount_percentage,
      selected: true,
    };
    dispatch(addSingleItem(addItem));
    dispatch(addOrder(addItem));
    clearAll();
  };

  const onChange = (event) => {
    const { value } = event.target;
    const { name, id } = value;
    setError({ value: false });
    updateItem((state) => ({
      ...state,
      name,
      item_id: id,
      sport_id: activeSport,
      id: Date.now(),
      original_unit_price: 0,
      unit_price: 0
    }));
    getFabrics(id);
  };

  const getFabrics = (id) => {
    fetch(
      `${apiConstants.API_URL}/price/items/sport/${activeSport}/item/${id}`,
      requestOptions
    ).then((response) => {
      response.text().then((text) => {
        const data = text && JSON.parse(text);
        setFabrics(data.data);
      });
    });
  };

  const getLinings = (id) => {
    fetch(
      `${apiConstants.API_URL}/price/items/sport/${activeSport}/item/${newItem.item_id}/fabric/${id}`,
      requestOptions
    ).then((response) => {
      response.text().then((text) => {
        const data = text && JSON.parse(text);
        const linings = data?.data;
        linings.push({
          lining_ids: [],
          combined_name: "No Lining",
          price_id: "",
        });
        setLinings(data?.data);
      });
    });
  };

  const getExtra = () => {
    fetch(`${apiConstants.API_URL}/extra-charges`, requestOptions).then(
      (response) => {
        response.text().then((text) => {
          const data = text && JSON.parse(text);
          setExtra(data.data);
        });
      }
    );
  };

  useEffect(() => {
    if (activeSport) {
      getExtra();
      fetch(
        `${apiConstants.API_URL}/price/items/sport/${activeSport}`,
        requestOptions
      ).then((res) => {
        res.text().then((text) => {
          const data = text && JSON.parse(text);
          if (!res.ok) {
            if (res.status === 401) {
              // logout()
            }
            const error = (data && data.error) || res.statusText;
            setToastMessage(error);
            setToastState({
              open: true,
              vertical: "top",
              horizontal: "right",
            });
          } else {
            setData(() => data?.data);
          }
        });
      });
      setEnableAdd(false);
    }
  }, [activeSport]);

  const onChangeFabric = (event) => {
    const { id, name, price_id } = event.target.value;
    setFabricPriceId(price_id);
    setPriceId(price_id);
    updateItem({ 
      ...newItem, 
      fabric_id: id, 
      fabric_name: name,
      original_unit_price: 0,
      unit_price: 0 
    });
    getLinings(id);
  };

  const onChangeLinings = (e) => {
    const value = e.target.value;
    let lining_names;
    if (value?.lining_ids !== 0) {
      lining_names = value?.combined_name?.split(",");
    } else {
      lining_names = "";
    }
    setPriceId(value?.price_id);
    updateItem({
      ...newItem,
      lining_ids: value?.lining_ids,
      lining_name: lining_names,
    });
  };

  const getPrice = () => {
    if (!newItem?.item_id) {
      setError({ value: true, name: "item", message: "Item is required" });
    } else if (!newItem?.fabric_id) {
      setError({ value: true, name: "fabric", message: "Fabric is required" });
    } else {
      const price_id =
        newItem?.lining_ids.length !== 0 ? priceId : fabricPriceId;
      setError({ value: false });
      fetch(
        `${apiConstants.API_URL}/price/${price_id}/qty/${newItem?.qty}`,
        requestOptions
      ).then((response) => {
        response.text().then((text) => {
          const data = text && JSON.parse(text);
          setOriginalUnitPrice(data?.data?.unit_price);
          let newUnitPrice = data?.data?.unit_price;
          if(discount){
            newUnitPrice = getDiscountedPrice(
              data?.data?.unit_price,
              discount.replace(/[^0-9.]/g, "") * 100
            );
          }
          updateItem({
            ...newItem,
            unit_price: newUnitPrice,
            price_id: data?.data?.price_id,
            original_unit_price: data?.data?.unit_price,
            original_total_price: data?.data?.unit_price * newItem?.qty,
            total_price: newUnitPrice * newItem?.qty,
          });
          setEnableAdd(newUnitPrice > 0);
          onChangeAllExtraQty(newItem?.qty);
        });
      });
    }
  };

  const onChangeQty = (e) => {
    updateItem({ 
      ...newItem, 
      qty: parseInt(e.target.value),
      original_unit_price: 0,
      unit_price: 0 
    });
    setQty(parseInt(e.target.value));
  };

  const onChangeAllExtraQty = (value) => {
    const updatedExtraCharges = extraCharges.map((charge) => ({
      ...charge,
      qty: value
    }));
    
    setExtraCharges(updatedExtraCharges);
    
    const totalExtra = updatedExtraCharges.reduce(
      (total, charge) => total + charge.cost * (charge.qty || 1),
      0
    );
    
    updateItem((state) => ({
      ...state,
      extra_charges: totalExtra,
      extra_charges_list: updatedExtraCharges
    }));
  };

  const onChangeStyleName = (e) => {
    updateItem({ ...newItem, style: e.target.value });
  };

  const onChangeDiscount = useCallback(
    (value) => {      
      setDiscount(value);
      const discount = value.replace(/[^0-9.]/g, "") * 100;

      let newUnitPrice = getDiscountedPrice(
        newItem.original_unit_price,
        discount
      );

      updateItem({
        ...newItem,
        unit_discount: discount,
        discount_percentage: value,
        unit_price: newUnitPrice,
        total_price: newItem.qty * newUnitPrice,
      });
    },
    [newItem, updateItem]
  );

  const onChangeUnitPrice = (e) => {
    let newUnitPrice = getDiscountedPrice(
      e.target.value * 100,
      newItem.unit_discount
    );

    updateItem({
      ...newItem,
      original_unit_price: e.target.value,
      unit_price: newUnitPrice,
      total_price: newItem.qty * newUnitPrice,
    });
    setEnableAdd(e.target.value * 100 >= originalUnitPrice);
    if (e.target.value * 100 >= originalUnitPrice) {
      setUnitPriceError(false);
    } else {
      setUnitPriceError(true);
    }
  };

  const onChangeExtra = (e) => {
    const { value } = e.target;
    setSelected((prevSelected) => ({
      ...value,
      reference: prevSelected?.reference || ""
    }));
  };

  const onChangeReference = (value) => {
    setSelected((prevSelected) => ({
      ...prevSelected,
      reference: value
    }));
  };

  useEffect(() => {
    if (extraCharges.length !== 0) {
      let newArra = [...extraCharges];
      let totalExtra = 0;
      newArra.map((e) => {
        totalExtra = totalExtra + e.cost * qty;
        return "";
      });
      updateItem((state) => ({
        ...state,
        extra_charges: totalExtra,
      }));
    }
  }, [qty]);

  const addExtraTotal = () => {
    let newselected = { ...selected, qty };
    if (selected.code && !extraCharges.some(x => x.id === selected.id && x.reference === selected.reference)) {
      let newArra = [...extraCharges];
      newArra.push(newselected);
      setExtraCharges(() => [...newArra]);
      
      let totalExtra = 0;
      newArra.map((e) => {
        totalExtra = totalExtra + e.cost * qty;
        return "";
      });
      updateItem((state) => ({
        ...state,
        extra_charges: totalExtra,
        extra_charges_list: [...newArra],
      }));
      onChangeReference("");
    }
  };

  const removeExtra = (index) => {
    let newArray = [];
    if (index >= 0 && index < extraCharges.length) {
      newArray = extraCharges.toSpliced(index, 1);
    }
    setExtraCharges([...newArray]);
    let totalExtra = 0;
    newArray.map((e) => {
      totalExtra = totalExtra + e.cost * qty;
      return "";
    });
    updateItem({
      ...newItem,
      extra_charges: totalExtra,
      extra_charges_list: [...newArray],
    });
    onChangeReference("");
  };

  const enableRequest = newItem.qty > 0;
  const showExtra = extraCharges.length > 0;

  return (
    <Modal
      open={open}
      onClose={clearAll}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack spacing={3}>
          <Stack direction={"row"} spacing={1}>
            <Typography
              id="modal-modal-title"
              fontWeight={500}
              fontSize={"20px"}
            >
              Add Item
            </Typography>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
            <FormControl fullWidth variant="standard">
              <InputLabel id="demo-simple-select-label">Select Item</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="item"
                size="small"
                onChange={onChange}
              >
                {data.map((d, index) => (
                  <MenuItem key={index} value={d}>
                    {d?.name}
                  </MenuItem>
                ))}
              </Select>
              {error.value && error.name === "item" && (
                <FormHelperText id="component-error-text" sx={{ color: "red" }}>
                  {error.message}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl fullWidth variant="standard">
              <InputLabel id="demo-simple-select-label">
                Select Fabric
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="fabric"
                size="small"
                onChange={onChangeFabric}
              >
                {fabrics?.map((d, index) => (
                  <MenuItem key={index} value={d}>
                    {d?.name}
                  </MenuItem>
                ))}
              </Select>
              {error.value && error.name === "fabric" && (
                <FormHelperText id="component-error-text" sx={{ color: "red" }}>
                  {error.message}
                </FormHelperText>
              )}
            </FormControl>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
            <FormControl style={{ width: "200px" }} variant="standard">
              <InputLabel id="demo-simple-select-label">
                Select Linings
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="fabric"
                size="small"
                onChange={onChangeLinings}
              >
                {linings?.map((l, index) => (
                  <MenuItem key={index} value={l}>
                    {(l?.combined_name).split(",").join(" + ")}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Input
              placeholder="Style Name"
              style={{ width: "250px" }}
              id="styleName"
              onChange={onChangeStyleName}
            />
            <Input
              type="number"
              min="0"  
              placeholder="Quantity"
              style={{ width: "100px" }}
              id="qty"
              onChange={onChangeQty}
            />
            <StyledPriceButton
              variant="contained"
              onClick={() => getPrice()}
              disabled={!enableRequest}
            >
              GET PRICE
            </StyledPriceButton>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
            <FormControl variant="standard">
              <TextField
                variant="standard"
                placeholder="Price"
                style={{ width: "250px" }}
                label="Unit Price"
                value={convertToPlaces(newItem.original_unit_price)}
                disabled
              />
              {unitPriceError && (
                <FormHelperText id="component-error-text" sx={{ color: "red" }}>
                  Unit price cannot be less than{" "}
                  {convertToPlaces(originalUnitPrice)}
                </FormHelperText>
              )}
            </FormControl>
            <TextField
              variant="standard"
              label="Discount"
              style={{ width: "250px" }}
              prefix="$"
              value={discount}
              onChange={(e) => onChangeDiscount(e.target.value)}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }} 
            />
            <TextField
              variant="standard"
              placeholder="Discounted Price"
              style={{ width: "250px" }}
              label="Discounted Price"
              disabled
              value={convertToPlaces(newItem.unit_price)}
            />
          </Stack>
          <Stack direction={"row"} spacing={3}>
            <FormControl fullWidth variant="standard">
              <InputLabel id="demo-simple-select-label">
                Select Extra Charges
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="item"
                size="small"
                onChange={onChangeExtra}
              >
                {extra.map((d, index) => (
                  <MenuItem key={index} value={d}>
                    {d?.name} - ({convertToPlaces(d?.cost)})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                variant="standard"
                label="Reference"
                style={{ width: "250px" }}
                value={selected.reference || ""}
                onChange={(e) => onChangeReference(e.target.value)}
              />
            </FormControl>
            <Button
              variant="outlined"
              onClick={() => addExtraTotal()}
              sx={{ minWidth: "160px" }}
              disabled={!newItem?.qty || !selected.reference}
            >
              ADD CHARGES
            </Button>
          </Stack>
          {showExtra && (
            <Stack sx={{ mt: "20px" }}>
              <Divider>
                <Typography fontWeight={500} fontSize={"20px"}>
                  EXTRA CHARGES
                </Typography>
              </Divider>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Code</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Cost</TableCell>
                    <TableCell>Reference</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {extraCharges.map((e, index) => (
                    <TableRow key={index}>
                      <TableCell>{e.code}</TableCell>
                      <TableCell>{e.name}</TableCell>
                      <TableCell>
                        {convertToPlaces(e.cost * (e.qty || 1))}
                      </TableCell>                      
                      <TableCell>{e.reference}</TableCell>
                      <TableCell>
                        <DeleteIcon
                          color="warning"
                          onClick={() => removeExtra(index)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      Add-ons {convertToPlaces(newItem.extra_charges)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Stack>
          )}
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Button color="success" onClick={() => clearAll()}>
              CLOSE
            </Button>
            <StyledButton
              color="success"
              onClick={() => handleSave()}
              variant="contained"
              disabled={!(enableAdd && newItem.style && newItem.original_unit_price > 0)}
            >
              ADD TO LIST
            </StyledButton>
          </Stack>
        </Stack>
        <AlertToast
          toastMessage={toastMessage}
          toastState={toastState}
          handleClose={handleToastClose}
        />
      </Box>
    </Modal>
  );
};

AddItemModal.prototype = {
  open: PropTypes.bool,

  handleClose: PropTypes.func.isRequired,
};
AddItemModal.defaultProps = {
  open: false,
};

export default AddItemModal;